var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.list?.length > 0)?_c('div',{staticClass:"new-list"},_vm._l((_vm.list.list),function(item,index){return _c('div',{key:index,staticClass:"news-item",class:{
      'item-arrows': _vm.type == 'arrows',
      'item-spot': _vm.type === 'spot',
      'item-dash': _vm.dash,
    },on:{"click":function($event){return _vm.toDetail(item,_vm.list.categoryCode)}}},[_c('div',{staticClass:"news-title"},[_vm._v(" "+_vm._s(item.articleName)+" ")]),_c('div',{staticClass:"news-time"},[_vm._v(" "+_vm._s(item.releaseTime)+" ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }